import { useEffect } from 'react';
import { useUi } from '../store/ui.ts';

/** 轻量提示条：操作成功 / 失败都需要即时反馈，原型完全没有这一层。 */
export function Toast() {
  const toast = useUi((s) => s.toast);
  const clearToast = useUi((s) => s.clearToast);

  useEffect(() => {
    if (!toast) return;
    const timer = window.setTimeout(clearToast, 2600);
    return () => window.clearTimeout(timer);
  }, [toast, clearToast]);

  if (!toast) return null;

  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        left: '50%',
        bottom: 96,
        transform: 'translateX(-50%)',
        zIndex: 60,
        maxWidth: 320,
        padding: '10px 16px',
        borderRadius: 12,
        fontSize: 12.5,
        lineHeight: 1.6,
        textAlign: 'center',
        background: toast.tone === 'error' ? 'rgba(255,93,126,.16)' : 'rgba(47,227,176,.16)',
        border: `1px solid ${toast.tone === 'error' ? 'rgba(255,93,126,.45)' : 'rgba(47,227,176,.45)'}`,
        color: 'var(--text)',
        backdropFilter: 'blur(12px)',
      }}
    >
      {toast.text}
    </div>
  );
}
